"use client";

import * as React from "react";
import { Scale, FileText, Car, HardHat, Tractor, Heart, Stethoscope, Shield } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  icon: Scale,
  title: "Odszkodowania z OC sprawcy",
  description: "Prowadzimy sprawy o odszkodowanie wynikające z odpowiedzialności cywilnej sprawcy zdarzenia.",
  delay: 0
}, {
  id: 2,
  icon: FileText,
  title: "Zadośćuczynienie za doznaną krzywdę",
  description: "Pomagamy w sprawach dotyczących zadośćuczynienia pieniężnego za ból, cierpienie oraz skutki zdarzeń losowych.",
  delay: 50
}, {
  id: 3,
  icon: Car,
  title: "Wypadki komunikacyjne",
  description: "Reprezentujemy osoby poszkodowane w wypadkach drogowych, w tym kierowców, pasażerów, pieszych i rowerzystów.",
  delay: 100
}, {
  id: 4,
  icon: HardHat,
  title: "Wypadki przy pracy",
  description: "Prowadzimy sprawy dotyczące wypadków przy pracy, w tym analizujemy odpowiedzialność pracodawcy.",
  delay: 150
}, {
  id: 5,
  icon: Tractor,
  title: "Wypadki rolnicze i KRUS",
  description: "Pomagamy osobom poszkodowanym w wypadkach w gospodarstwach rolnych oraz sprawach związanych z KRUS.",
  delay: 200
}, {
  id: 6,
  icon: Heart,
  title: "Śmierć osoby bliskiej",
  description: "Reprezentujemy członków rodzin osób, które poniosły śmierć w wyniku wypadku lub innego zdarzenia.",
  delay: 250
}, {
  id: 7,
  icon: Stethoscope,
  title: "Błędy medyczne",
  description: "Prowadzimy sprawy dotyczące odpowiedzialności za zdarzenia medyczne z analizą dokumentacji.",
  delay: 300
}, {
  id: 8,
  icon: Shield,
  title: "Reprezentacja prawna",
  description: "Zapewniamy kompleksową obsługę prawną na etapie przedsądowym oraz sądowym.",
  delay: 350
}];
export default function NaszeUslugi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="nasze-usługi" ref={ref} className="bg-background py-16 md:py-24 lg:py-32 px-4 md:px-8">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-foreground mb-4 !text-4xl">Nasze usługi</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto !text-2xl">Zapewniamy profesjonalną pomoc prawną w sprawach odszkodowawczych na terenie Słupska i okolic</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <Card key={service.id} data-index={i} className={`group border border-border hover:border-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:shadow-medium hover:-translate-y-1 ${isVisible ? "animate-reveal" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${service.delay}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-md bg-primary-light text-primary group-hover:bg-primary group-hover:text-foreground-primary transition-colors duration-[var(--duration-medium)]">
                    <IconComponent className="w-7 h-7" aria-hidden="true" />
                  </div>
                  <CardTitle className="text-xl mb-2">{service.title}</CardTitle>
                  <CardDescription className="text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <Link to="/ServicesPage" className="inline-flex items-center text-primary font-semibold group-hover:translate-x-1 transition-transform duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
                    Dowiedz się więcej
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}